import { useEffect, useState } from "react";
import Logo from "./Logo";
import { Menu, X } from "lucide-react";
import { openCalendly } from "@/lib/calendly";

const NAV = [
  { href: "#assessment", label: "Assessment" },
  { href: "#how", label: "How it works" },
  { href: "#who", label: "Who it's for" },
  { href: "#scorecard", label: "Scorecard" },
  { href: "#faq", label: "FAQ" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-200 ${
        scrolled ? "bg-white/85 backdrop-blur-xl border-zinc-200" : "bg-white/60 backdrop-blur-md border-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12 h-16 flex items-center justify-between">
        <a href="#top" aria-label="Fynix Systems" data-testid="header-logo-link">
          <Logo />
        </a>

        <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-600 hover:text-zinc-950 transition-colors"
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#book"
            onClick={(e) => {
              e.preventDefault();
              openCalendly();
            }}
            className="hidden sm:inline-flex items-center gap-2 bg-zinc-950 text-white px-4 py-2.5 text-sm font-medium border border-zinc-950 hover:-translate-y-0.5 hover:shadow-[4px_4px_0px_0px_rgba(234,88,12,1)] transition-all duration-200"
            data-testid="header-book-cta"
          >
            Book Assessment
            <span className="font-mono text-[10px] opacity-70">→</span>
          </a>
          <button
            className="md:hidden p-2 text-zinc-900"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Close menu" : "Open menu"}
            data-testid="header-mobile-toggle"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-zinc-200 bg-white" data-testid="mobile-nav">
          <div className="px-6 py-4 flex flex-col gap-4">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="font-mono text-xs uppercase tracking-[0.18em] text-zinc-700"
                data-testid={`mobile-nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {n.label}
              </a>
            ))}
            <a
              href="#book"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center bg-zinc-950 text-white px-4 py-3 text-sm font-medium"
              data-testid="mobile-book-cta"
            >
              Book Assessment →
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
